var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "login" }, [
    _c("div", { staticClass: "login-card-opacity" }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "login-card" },
      [
        _c("img", {
          staticClass: "logo",
          attrs: { src: require("@/assets/img/warning-denied.svg") }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "title-denied" }, [_vm._v("Access Denied")]),
        _vm._v(" "),
        _c("div", { staticClass: "desc-denied" }, [
          _vm._v(
            "Sorry you do not have permission.\n    Please contact your administrator."
          )
        ]),
        _vm._v(" "),
        _c(
          "b-button",
          {
            staticClass: "btn-login",
            on: {
              click: function($event) {
                _vm.$router.push("/login")
              }
            }
          },
          [_vm._v("\n      Back to Login Page\n    ")]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "login-card-copy" }, [
      _c("p", [_vm._v("Version 2.64.5")]),
      _vm._v(" "),
      _c(
        "p",
        [
          _vm._v("Powered by\n      "),
          _c(
            "b-link",
            { attrs: { href: "https://officeless.studio/", target: "_blank" } },
            [_c("strong", [_vm._v("Jojonomic")])]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1fa394d5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1fa394d5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/login/jDenied.vue
// module id = null
// module chunks = 